export default "__VITE_ASSET__oYNeYNMw__"